import { cloneDeep } from "lodash";

const mapToDefaultTagFamilies = [
  {
    tag: "tags.1_application_area",
    name: "Application Area",
    availableValues: [],
    setValues: []
  },
  {
    tag: "tags.2_luminaire_archetype",
    name: "Luminaire Archetypes",
    availableValues: [],
    setValues: []
  }
];

/**
 * Maps filters from drivers or modules to tagFamilies
 * @param filters
 * @returns {*[]}
 */
function mapTagFamilies(filters) {
  const mapTagFamilies = cloneDeep(mapToDefaultTagFamilies);
  mapTagFamilies.map(tagFamily => {
    // find item of filterSet in tagFamily map
    const foundItem = filters.find(filter => filter.name === tagFamily.tag);
    if (foundItem) {
      tagFamily.availableValues = foundItem.availableValues;
      tagFamily.setValues = foundItem.value;
    }
  });

  return mapTagFamilies;
}

function mergeMapTagFamilies(mapA, mapB) {
  const mergedMapTagFamilies = cloneDeep(mapA);
  mergedMapTagFamilies.map(tagFamilyA => {
    // find item of filterSet in tagFamily map
    const foundItem = mapB.find(
      tagFamilyB => tagFamilyB.tag === tagFamilyA.tag
    );
    if (foundItem) {
      // Map trough available values in found item
      foundItem.availableValues.map(availableValue => {
        // Find value in available values, for they can overlap between module and driver
        let foundAvailableValue = tagFamilyA.availableValues.find(
          value => value.value === availableValue.value
        );
        if (!foundAvailableValue) {
          // If new item add to values array of tagFamily map
          tagFamilyA.availableValues.push(availableValue);
        } else {
          // If already exist (because filter exist in both module and driver), dont add but increment count of value.
          foundAvailableValue.count += availableValue.count;
        }
      });

      // Map trough set values in found item
      if (foundItem.setValues != null) {
        foundItem.setValues.map(setValue => {
          // Find set values, for they can overlap between module and driver
          let foundSetValue = tagFamilyA.setValues.find(
            value => value.value === setValue.value
          );
          if (!foundSetValue) {
            // If new item add to values array of tagFamily set values
            tagFamilyA.setValues.push(setValue);
          }
        });
      }
    }
    return tagFamilyA;
  });

  // Move items with count 0 to the end of the array
  mergedMapTagFamilies.map(tagFamily => {
    // Get empty values and sort them by value
    const emptyValues = tagFamily.availableValues
      .filter(value => value.count === 0)
      .sort((a, b) => {
        return a.value > b.value ? 1 : -1;
      });

    // Filter out empty values
    tagFamily.availableValues = tagFamily.availableValues.filter(
      value => value.count !== 0
    );

    // Add sorted empty values back at the end of the array
    emptyValues.map(emptyValue => {
      tagFamily.availableValues.push(emptyValue);
    });
  });

  return mergedMapTagFamilies;
}

export { mapTagFamilies, mergeMapTagFamilies };
